import { Formik } from 'formik';
import SiteHeader from '../SiteHeader/index';
import SiteFooter from '../SiteFooter/index';
import RSValidation from '../../formControllers/Validation/RSValidation';
import SurveyHeader from './SurveyHeader';
import RSForm from './RSForm';
import State from '../../handlers/State';
import { setInitialValues } from './utils';
import { useEffect } from 'react';
import { onLink, unloadCallback } from '../../handlers';
import ReactGA from 'react-ga4';
import { openPreview } from '../Preview/utils';
import { Box } from '@chakra-ui/react';

//format me
const RSSurvey = ({ data, userID }) => {
  const props = State(data, userID);
  ReactGA.send({
    hitType: 'pageview',
    page: '/',
    title: 'Home',
  });
  useEffect(() => {
    props.stateProps.setResumeData({
      resumes: props.stateProps.resumes,
    });
  }, []);
  useEffect(() => {
    const savedResumes = {};
    savedResumes['resumes'] = data.member;
    props.stateProps.setDataToSave({
      saved: savedResumes,
      industry: data.industry,
    });
  }, []);
  useEffect(() => {


    window.addEventListener('beforeunload', unloadCallback);
    return () => window.removeEventListener('beforeunload', unloadCallback);
  }, []);
  const initialValues = setInitialValues(props, data);
  const validationSchema = RSValidation(
    props.sections,
  );
  if (window.preview !== undefined && window.preview !== 0) {
    props.stateProps.setIsAdmin(true);
    props.stateProps.sectionData.sectionName = 'preview';
    props.stateProps.sectionData.resumeIndex = window.preview-1;
    window.preview=0;
  }
  return (
    < >
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={validationSchema}
      >
        {formikProps => {
          props.formikProps = formikProps;
          if (props.stateProps.sectionData.sectionName !== 'parser') {
            const resumeIndex = props.stateProps.sectionData.resumeIndex;
            const resumes = props.stateProps.dataToSave.saved.resumes;
            if (typeof resumes[resumeIndex] === 'undefined') {
              resumes[resumeIndex] = {};
            }
            //resumes[resumeIndex].parsed = true;
            if (typeof resumes[resumeIndex].parser !== 'undefined') {
              resumes[resumeIndex].parser[0].P1 = '';
            }
          }
            return (
              <Box  >
                <>
                  <SiteHeader props={props}  />
                  <SurveyHeader props={props} />
                  <RSForm props={props} formikProps={formikProps} />
                </>
                <SiteFooter stateProps={props.stateProps} />
              </Box>
            );
        }
        }
      </Formik>
    </>
  );
};

export default RSSurvey;
